import { inject, observer } from 'mobx-react';
import { useEffect, useState } from "react";
import * as React from 'react';

import { ResultsSubHeader as SharedUIResultsSubHeader } from '@shared-ui/lodging-property-listing';

import { SearchCriteriaModel } from "stores/models";

export interface ResultsSubHeaderWrapperProps {
  searchInputs?: any;
  searchCriteria?: SearchCriteriaModel;
  criteriaChanged?: boolean;
  localizedText?: string;
}

export const ResultsSubHeaderWrapper: React.FunctionComponent<ResultsSubHeaderWrapperProps> = inject('context', 'searchCriteria')(
  observer(
    ({
       searchInputs,
       criteriaChanged,
       localizedText,
    }: ResultsSubHeaderWrapperProps) => {
    const [inputs, setInputs] = useState(searchInputs);

    useEffect(() => {
      if (criteriaChanged) {
        setInputs(searchInputs);
      }
    }, [criteriaChanged]);

    return (
      // TODO: Remove this once we figure out why ResultsSubHeader is forcing data to be passed as a prop
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      <SharedUIResultsSubHeader inputs={inputs} localizedText={localizedText} />
    );
  })
);

ResultsSubHeaderWrapper.displayName = 'ResultsSubHeaderWrapper';
